<scitis-app-global-page-header [pageTitle]="'Machine administration'">

  <ng-template #entryCount>
    <div class="page-header-counts">
      <div class="count">
        <span class="badge badge-pill badge-primary" [innerText]="machinesCount"></span>
        <span class="count-label" translate>Machines</span>
      </div>
    </div>
  </ng-template>

  <ng-template #filterElement>
    <div class="search">
      <input [(ngModel)]="searchTerm" (change)="onSearchForMachines($event)"
             [placeholder]="('Search machine' | translate) + '...'"
             class="form-control"
             type="search">
    </div>
  </ng-template>

  <ng-template #filterElement>
    <div #dropdownFilter="ngbDropdown"
         [autoClose]="'outside'" class="d-inline-block"
         ngbDropdown placement="bottom-right">
      <button class="btn btn-outline-primary" id="dropdownFilter" ngbDropdownToggle>
        <span [class.d-none]="appliedNumberOfFilters!==0" class="fa-solid fa-filter"></span>
        <span [class.d-none]="appliedNumberOfFilters===0" [innerText]="appliedNumberOfFilters"
              class="badge badge-pill badge-primary badge-round mr-1"></span>
        <span translate>Filter</span>
      </button>
      <div aria-labelledby="dropdownFilter" class="p-3 dropdown-filters" ngbDropdownMenu>
        <div class="form-group">
          <label for="selectOrganization" translate>Organization</label>
          <ng-select (change)="onChangeOrganization($event)"
                     (mousedown)="$event.stopPropagation()"
                     [(ngModel)]="selectedOrganizationId"
                     [clearable]="userRole.isSuperAdminRole"
                     [disabled]="addMachineButtonDisabled"
                     [items]="organizations"
                     [placeholder]="'Select organization'|translate"
                     bindLabel="name" bindValue="id"
                     id="selectOrganization"
                     style="width: 220px;">
            <ng-template ng-option-tmp let-item="item">
              <div [title]="item.name" [innerHTML]="item.name" class="dropdown-tooltip-hover-administration"></div>
            </ng-template>
          </ng-select>
        </div>
        <div class="form-group">
          <label for="selectMachineryGroups" translate>Machinery group</label>
          <ng-select (change)="onChangeMachineryGroup($event)"
                     (mousedown)="$event.stopPropagation()"
                     [(ngModel)]="selectedMachineryGroupId"
                     [clearable]="userRole.isSuperAdminRole"
                     [disabled]="addMachineButtonDisabled"
                     [items]="machineryGroupsList"
                     [placeholder]="'Select machinery group'|translate"
                     bindLabel="name"
                     bindValue="id"
                     id="selectMachineryGroups"
                     style="width: 220px;">
            <ng-template ng-option-tmp let-item="item">
              <div [title]="item.name" [innerHTML]="item.name" class="dropdown-tooltip-hover-administration"></div>
            </ng-template>
          </ng-select>
        </div>
        <div class="form-group form-check">
          <input (change)="onShowOnlyTemplateMachinesChange($event)" [disabled]="addMachineButtonDisabled"
                 class="form-check-input"
                 id="checkTemplates"
                 type="checkbox">
          <label class="form-check-label" for="checkTemplates">Show only template machines</label>
        </div>
        <button (click)="onApplyFilterClick(); dropdownFilter.close();"
                [disabled]="addMachineButtonDisabled"
                class="btn btn-primary btn-block"
                translate>Apply filters
        </button>
      </div>
    </div>
  </ng-template>


  <ng-template #filterElement>
    <button (click)="onAddMachine()"
            [disabled]="(!userRole.isAdminRole && !userRole.isSuperAdminRole && !userRole.isTechAdminRole) || addMachineButtonDisabled"
            class="btn btn-primary">
      <span class="fa-solid fa-plus"></span>
      <span translate>New machine</span>
    </button>
  </ng-template>

</scitis-app-global-page-header>

<div class="card card-table-view mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table vertical-align-middle mb-0">
        <thead>
        <tr>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="type">
            <span translate>Display name / Name</span>
          </th>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="tenant">
            <span translate>Organization</span>
          </th>

          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="location">
            <span translate>Location</span>
          </th>

          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="projectId">
            <span translate>Google Project ID</span>
          </th>

          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="category">
            <span translate>Category</span>
          </th>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="machineTag">
            <span translate>Tag</span>
          </th>

          <th class="text-right" scope="col">
            <span translate>Action</span>
          </th>
        </tr>
        </thead>
        <tbody>

        <tr
          *ngFor="let machine of machinesList | paginate: paginateSettings">
          <td>
            <strong class="truncate d-block" style="max-width: 280px;">
              <ngb-highlight [result]="machine.type" [term]="searchTerm" [title]="machine.type"></ngb-highlight>
            </strong>
            <span class="text-muted d-block truncate" style="max-width: 280px;">
              <span translate>Name</span>:
               <ngb-highlight [result]="machine.name" [term]="searchTerm" [title]="machine.name"></ngb-highlight>
            </span>
          </td>
          <td>
            <ngb-highlight [result]="getOrganizationAsString(machine)" [term]="searchTerm"
                           [title]="getOrganizationAsString(machine)" class="truncate truncate-lg"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="machine.location" [term]="searchTerm"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="machine.projectId" [term]="searchTerm"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="categoryDisplayNameMap.get(machine.category)" [term]="searchTerm"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="machine.machineTag" [term]="searchTerm" class="d-block"></ngb-highlight>
            <span *ngIf="machine.templateMachine" class="badge badge-pill badge-primary" translate>Template</span>
          </td>

          <td class="text-right">
            <scitis-admin-machine-action (machineDeleteEvent)="onDeleteMachineSuccess(machine)"
                                         (machineUpdatedEvent)="onMachineUpdated($event)"
                                         [userRole]="userRole"
                                         [machine]="machine"
                                         [searchTerm]="searchTerm"
                                         [firebaseUserId]="firebaseUserId">
            </scitis-admin-machine-action>
          </td>
        </tr>
        </tbody>
      </table>
      <div *ngIf="machinesList.length === 0"
           class="d-flex align-items-center justify-content-center mb-0 mt-3 alert alert-info text-center">
        <em class="fa-solid fa-circle-info mr-2"></em>
        <span translate>No machines found for searched term and filters.</span>
      </div>
    </div>
  </div>
</div>

<scitis-ngx-pagination [id]="paginateSettings.id"
                       paginationClass="col"
                       [itemsPerPage]="paginateSettings.itemsPerPage"
                       [itemsPerPageOptions]="itemsPerPageOptions"
                       (itemsPerPageChange)="onItemsPerPageChange($event)"
                       (pageNumberChange)="onLoadPageNumber($event)">
</scitis-ngx-pagination>
